/**
 * Copyright © Veeam Software Group GmbH.
 */

import { WeekInMonthRepresentation } from '@veeam-vspc/models/web-controllers';

export type DayInMonth = WeekInMonthRepresentation;
export const DayInMonth = WeekInMonthRepresentation;
